import { ActionBarsEffects } from './action-bars.effect';

export const effects = [ActionBarsEffects];
export * from './action-bars.effect';
